import request from "./useRequests";
import { userinfo } from '@/stores/counter'
import { ElMessage } from 'element-plus'

export default function uselogout() {
  const user = userinfo()
  async function logout() {
    request.delete('/user/logout')
      .then(res => {
        // console.log(res)
        if (res.data.success == true) {
          ElMessage({
            showClose: true,
            message: '已退出',
            type: 'success',
          })
          user.signup = false;
          user.login = false;
          user.baseInfo = {
            id: '',
            address: '',//区域
            career: '',
            nickname: '',
            telephone: '',
            status: NaN
          }
        }
        else {
          ElMessage({
            showClose: true,
            message: `${res.data.message}`,
            type: 'error',
          })
        }
      })
  }


  return {
    logout
  }
}